webpackJsonp([4],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);


var EventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]();

/* harmony default export */ __webpack_exports__["a"] = (EventBus);

/***/ }),
/* 5 */,
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  permissionMenuMap: {
    'dashboard': '控制面板',
    'admin': '管理',
    'admin:user': '用户',
    'admin:role': '角色',
    'admin:permission': '权限',
    'admin:driver': '司机',
    'admin:car': '车库',
    'admin:userOrder': '用户订单'
  }
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layout_SideMenu__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layout_Navigator__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layout_TopMenu__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Login__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constant__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      errorMessage: '',
      loginSettle: false
    };
  },

  computed: {
    permissions: function permissions() {
      var permissionArr = this.$store.state.user.permissions || [];
      var result = {};
      permissionArr.forEach(function (permission) {
        result[permission] = {
          name: permission,
          menuName: __WEBPACK_IMPORTED_MODULE_4__constant__["a" /* default */].permissionMenuMap[permission] || 'Unknown menu'
        };
      });
      return result;
    },
    notLogin: function notLogin() {
      var result = true;
      if (this.$store.state.user && this.$store.state.user.userInfo) {
        result = false;
      }
      return result;
    }
  },
  created: function created() {
    var _this = this;

    // Get the login info or session
    this.$http.get('sessions').then(function (res) {
      _this.loginSettle = true;

      var data = res.data ? res.data.data[0] : null;
      if (data && data.id && data.username) {
        _this.$store.commit('updateUser', data);
        _this.$router.replace('dashboard'); // User should at least have the dashborad permission
      } else {
        _this.$store.commit('clearUser');
      }
    }, function (err) {
      _this.$store.commit('clearUser');
      console.error('App - session request error', err);
    });
  },

  components: {
    'login-view': __WEBPACK_IMPORTED_MODULE_3__components_Login__["a" /* default */],
    'side-menu': __WEBPACK_IMPORTED_MODULE_0__components_layout_SideMenu__["a" /* default */],
    'navigator': __WEBPACK_IMPORTED_MODULE_1__components_layout_Navigator__["a" /* default */],
    'top-menu': __WEBPACK_IMPORTED_MODULE_2__components_layout_TopMenu__["a" /* default */]
  }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      userInfo: this.$store.state.user ? this.$store.state.user.userInfo : {},
      roles: this.$store.state.user ? this.$store.state.user.roles : [],
      permissions: this.$store.state.user ? this.$store.state.user.permissions : []
    };
  }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    function validateUsername(rule, value, callback) {
      if (value === '') {
        callback(new Error('Please input email or username'));
      } else {
        callback();
      }
    }

    function validatePassword(rule, value, callback) {
      if (value === '') {
        callback(new Error('Please input password'));
      } else {
        callback();
      }
    }

    return {
      tip: true,
      formLogin: {
        username: '',
        password: ''
      },
      ruleCustom: {
        username: [{ validator: validateUsername, trigger: 'blur' }],
        password: [{ validator: validatePassword, trigger: 'blur' }]
      }
    };
  },

  methods: {
    handleSubmit: function handleSubmit(name) {
      var _this = this;

      this.$refs[name].validate(function (valid) {
        if (valid) {
          _this.$http.post('sessions', {
            username: _this.formLogin.username,
            password: _this.formLogin.password
          }).then(function (res) {
            var data = res.data.data;
            if (data && data.id && data.username) {
              _this.$store.commit('updateUser', data);
              _this.$router.replace('/dashboard'); // All user should have dashboard permission
            }
          });
        } else {
          _this.$Message.error('Invalid input');
        }
      });
    },
    handleReset: function handleReset(name) {
      this.$refs[name].resetFields();
    }
  }
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _ = __webpack_require__(5);
var moment = __webpack_require__(0);

var defaultPermissions = ['控制面板 ', '管理员 ', '管理员 :用户', '管理:角色', '管理:许可'];
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var _this = this;

    return {
      dataModel: {},
      rules: {
        name: [{ required: true, message: '角色名称不能为空', trigger: 'blur' }, { type: 'string', min: 3, message: '名称不能少于3位', trigger: 'blur' }],
        comment: [{ required: true, message: '角色备注不能为空', trigger: 'blur' }, { type: 'string', min: 2, message: '备注不能少于2位', trigger: 'blur' }]
      },
      editModal: false,
      destroyModal: false,
      destroyData: null,
      totalCount: 0,
      pageSize: 10,
      currentPage: 1,
      tableData: [],
      tableColumns: [{
        title: 'ID',
        key: 'id',
        align: 'center'
      }, {
        title: '角色',
        key: 'name',
        align: 'center'
      }, {
        title: '备注',
        key: 'comment',
        align: 'center'
      }, {
        title: '创建时间',
        key: 'createdAt',
        align: 'center',
        render: function render(h, params) {
          return h('span', {}, moment(params.row.createdAt).format('YYYY-MM-DD HH:mm:ss'));
        }
      }, {
        title: '更新时间',
        key: 'updatedAt',
        align: 'center',
        render: function render(h, params) {
          return h('span', {}, moment(params.row.updatedAt).format('YYYY-MM-DD HH:mm:ss'));
        }
      }, {
        title: '操作',
        key: 'actions',
        align: 'center',
        render: function render(h, params) {
          return h('div', [h('Button', {
            props: {
              type: 'primary',
              size: 'small',
              disabled: params.row.name && _.includes(defaultPermissions, params.row.name)
            },
            style: {
              marginRight: '5px'
            },
            on: {
              click: function click() {
                _this.showEdit(params.index);
              }
            }
          }, '编辑'), h('Button', {
            props: {
              type: 'error',
              size: 'small',
              disabled: params.row.name && _.includes(defaultPermissions, params.row.name)
            },
            on: {
              click: function click() {
                _this.showDestroy(params.index);
              }
            }
          }, '删除')]);
        }
      }]
    };
  },
  created: function created() {
    this.changePage(1);
  },

  methods: {
    changePage: function changePage(page) {
      var _this2 = this;

      this.currentPage = page;
      this.$http.get('admin/permissions?limit=10&offset=' + ((page || 1) - 1) * this.pageSize).then(function (res) {
        var data = res.data.data;
        _this2.tableData = data.rows;
        _this2.totalCount = data.count;
      });
    },
    showCreate: function showCreate() {
      this.dataModel = {};
      this.editModal = true;
    },
    showDestroy: function showDestroy(index) {
      this.destroyData = this.tableData[index];
      this.destroyModal = true;
    },
    destroy: function destroy(result) {
      var _this3 = this;

      if (result && this.destroyData) {
        this.$http.delete('admin/permissions/' + this.destroyData.id).then(function () {
          _this3.$Message.success('删除成功!');
          _this3.refresh();
        });
      }
      this.destroyModal = false;
    },
    refresh: function refresh() {
      if (this.currentPage) {
        this.changePage(this.currentPage);
      }
    },
    showEdit: function showEdit(index) {
      var data = this.tableData[index];
      this.dataModel.id = data.id;
      this.dataModel.name = data.name;
      this.dataModel.comment = data.comment;
      this.editModal = true;
    },
    edit: function edit(result) {
      var _this4 = this;

      if (result) {
        this.$refs['dataModel'].validate(function (valid) {
          if (valid) {
            var dataId = _this4.dataModel.id;
            if (dataId) {
              // 编辑
              _this4.$http.put('admin/permissions/' + dataId, {
                name: _this4.dataModel.name || undefined,
                comment: _this4.dataModel.comment || undefined
              }).then(function () {
                _this4.$Message.success('编辑成功!');
                _this4.refresh();
              });
            } else {
              // 新增
              _this4.$http.post('admin/permissions', {
                name: _this4.dataModel.name || undefined,
                comment: _this4.dataModel.comment || undefined
              }).then(function () {
                _this4.$Message.success('新增成功!');
                _this4.refresh();
              });
            }
          } else {
            _this4.$Message.error('表单验证失败!');
          }
        });
      } else {
        // TODO - 页面值不会被重置 - https://github.com/iview/iview/issues/970
        // this.$refs['dataModel'].resetFields();
      }
    }
  }
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _ = __webpack_require__(5);
var moment = __webpack_require__(0);

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var _this = this;

    return {
      allPermissions: [],
      dataModel: {},
      rules: {
        name: [{ required: true, message: '角色名称不能为空', trigger: 'blur' }, { type: 'string', min: 3, message: '名称不能少于3位', trigger: 'blur' }],
        comment: [{ required: true, message: '角色备注不能为空', trigger: 'blur' }, { type: 'string', min: 2, message: '备注不能少于2位', trigger: 'blur' }]
      },
      permissionModal: false,
      editModal: false,
      destroyModal: false,
      destroyData: null,
      totalCount: 0,
      pageSize: 10,
      currentPage: 1,
      tableData: [],
      tableColumns: [{
        title: 'ID',
        key: 'id',
        align: 'center'
      }, {
        title: '角色',
        key: 'name',
        align: 'center'
      }, {
        title: '备注',
        key: 'comment',
        align: 'center'
      }, {
        title: '创建时间',
        key: 'createdAt',
        align: 'center',
        render: function render(h, params) {
          return h('span', {}, moment(params.row.createdAt).format('YYYY-MM-DD HH:mm:ss'));
        }
      }, {
        title: '更新时间',
        key: 'updatedAt',
        align: 'center',
        render: function render(h, params) {
          return h('span', {}, moment(params.row.updatedAt).format('YYYY-MM-DD HH:mm:ss'));
        }
      }, {
        title: '操作',
        key: 'actions',
        align: 'center',
        render: function render(h, params) {
          return h('div', [h('Button', {
            props: {
              type: 'primary',
              size: 'small',
              disabled: params.row.name && (params.row.name === 'admin' || params.row.name === 'member')
            },
            style: {
              marginRight: '5px'
            },
            on: {
              click: function click() {
                _this.showEdit(params.index);
              }
            }
          }, '编辑'), h('Button', {
            props: {
              type: 'warning',
              size: 'small'
            },
            style: {
              marginRight: '5px'
            },
            on: {
              click: function click() {
                _this.showEditPermissions(params.index);
              }
            }
          }, '权限'), h('Button', {
            props: {
              type: 'error',
              size: 'small',
              disabled: params.row.name && (params.row.name === 'admin' || params.row.name === 'member')
            },
            on: {
              click: function click() {
                _this.showDestroy(params.index);
              }
            }
          }, '删除')]);
        }
      }]
    };
  },
  created: function created() {
    var _this2 = this;

    this.changePage(1);
    this.$http.get('admin/permissions?limit=1000').then(function (res) {
      var data = res.data.data;
      _this2.allPermissions = data.rows;
    });
  },

  methods: {
    changePage: function changePage(page) {
      var _this3 = this;

      this.currentPage = page;
      this.$http.get('admin/roles?limit=10&offset=' + ((page || 1) - 1) * this.pageSize).then(function (res) {
        var data = res.data.data;
        _this3.tableData = data.rows;
        _this3.totalCount = data.count;
      });
    },
    showCreate: function showCreate() {
      this.dataModel = {};
      this.editModal = true;
    },
    showEditPermissions: function showEditPermissions(index) {
      var data = this.tableData[index];
      this.dataModel.id = data.id;
      var allPermissions = this.allPermissions;
      var userPermissions = data.permissions;
      _.forEach(allPermissions, function (permission) {
        permission.selected = false;
        _.forEach(userPermissions, function (userPermission) {
          if (permission.name === userPermission.name) {
            permission.selected = true;
            return false;
          }
        });
      });
      this.dataModel.permissions = allPermissions;
      this.permissionModal = true;
    },
    editPermission: function editPermission(result) {
      var _this4 = this;

      if (result) {
        var permissions = [];
        _.forEach(this.dataModel.permissions, function (permission) {
          if (permission.selected) {
            permissions.push(permission.name);
          }
        });
        this.$http.put('admin/roles/' + this.dataModel.id + '/permissions', {
          permissions: permissions
        }).then(function () {
          _this4.$Message.success('更新成功!');
          _this4.refresh();
        });
      }
      this.permissionModal = false;
    },
    showDestroy: function showDestroy(index) {
      this.destroyData = this.tableData[index];
      this.destroyModal = true;
    },
    destroy: function destroy(result) {
      var _this5 = this;

      if (result && this.destroyData) {
        this.$http.delete('admin/roles/' + this.destroyData.id).then(function () {
          _this5.$Message.success('删除成功!');
          _this5.refresh();
        });
      }
      this.destroyModal = false;
    },
    refresh: function refresh() {
      if (this.currentPage) {
        this.changePage(this.currentPage);
      }
    },
    showEdit: function showEdit(index) {
      var data = this.tableData[index];
      this.dataModel.id = data.id;
      this.dataModel.name = data.name;
      this.dataModel.comment = data.comment;
      this.editModal = true;
    },
    edit: function edit(result) {
      var _this6 = this;

      if (result) {
        this.$refs['dataModel'].validate(function (valid) {
          if (valid) {
            var dataId = _this6.dataModel.id;
            if (dataId) {
              // 编辑
              _this6.$http.put('admin/roles/' + dataId, {
                name: _this6.dataModel.name || undefined,
                comment: _this6.dataModel.comment || undefined
              }).then(function () {
                _this6.$Message.success('编辑成功!');
                _this6.refresh();
              });
            } else {
              // 新增
              _this6.$http.post('admin/roles', {
                name: _this6.dataModel.name || undefined,
                comment: _this6.dataModel.comment || undefined
              }).then(function () {
                _this6.$Message.success('新增成功!');
                _this6.refresh();
              });
            }
          } else {
            _this6.$Message.error('表单验证失败!');
          }
        });
      } else {
        // TODO - 页面值不会被重置 - https://github.com/iview/iview/issues/970
        // this.$refs['dataModel'].resetFields();
      }
    }
  }
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _ = __webpack_require__(5);
var moment = __webpack_require__(0);

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var _this = this;

    return {
      allRoles: [],
      dataModel: {},
      rules: {
        username: [{ required: true, message: '姓名不能为空', trigger: 'blur' }, { type: 'string', min: 3, message: '姓名不能少于3位', trigger: 'blur' }],
        password: [{ type: 'string', min: 6, message: '密码不能少于6位', trigger: 'blur' }]
      },
      editModal: false,
      destroyModal: false,
      destroyData: null,
      totalCount: 0,
      pageSize: 10,
      currentPage: 1,
      tableData: [],
      tableColumns: [{
        title: 'ID',
        key: 'id',
        align: 'center'
      }, {
        title: '用户名',
        key: 'username',
        align: 'center'
      }, {
        title: '角色',
        key: 'roles',
        align: 'center',
        render: function render(h, params) {
          var roles = params.row.roles || [];
          var roleNames = roles.map(function (role) {
            return role.name;
          });
          return h('span', {}, roleNames.join(', ') || '-');
        }
      }, {
        title: '状态',
        key: 'disabled',
        align: 'center',
        render: function render(h, params) {
          var disabled = params.row.disabled;
          var color = disabled ? 'error' : 'success';
          var text = disabled ? '禁用' : '启用';
          return h('Tag', {
            props: {
              type: 'dot',
              color: color
            }
          }, text);
        }
      }, {
        title: '创建时间',
        key: 'createdAt',
        align: 'center',
        render: function render(h, params) {
          return h('span', {}, moment(params.row.createdAt).format('YYYY-MM-DD HH:mm:ss'));
        }
      }, {
        title: '更新时间',
        key: 'updatedAt',
        align: 'center',
        render: function render(h, params) {
          return h('span', {}, moment(params.row.updatedAt).format('YYYY-MM-DD HH:mm:ss'));
        }
      }, {
        title: '操作',
        key: 'actions',
        align: 'center',
        render: function render(h, params) {
          return h('div', [h('Button', {
            props: {
              type: 'primary',
              size: 'small'
            },
            style: {
              marginRight: '5px'
            },
            on: {
              click: function click() {
                _this.showEdit(params.index);
              }
            }
          }, '编辑'), h('Button', {
            props: {
              type: 'error',
              size: 'small',
              disabled: params.row.username && params.row.username === 'admin'
            },
            on: {
              click: function click() {
                _this.showDestroy(params.index);
              }
            }
          }, '删除')]);
        }
      }]
    };
  },
  created: function created() {
    var _this2 = this;

    this.changePage(1);
    this.$http.get('admin/roles?limit=100').then(function (res) {
      var data = res.data.data;
      _this2.allRoles = data.rows;
    });
  },

  methods: {
    changePage: function changePage(page) {
      var _this3 = this;

      this.currentPage = page;
      this.$http.get('admin/users?limit=10&offset=' + ((page || 1) - 1) * this.pageSize).then(function (res) {
        var data = res.data.data;
        _this3.tableData = data.rows;
        _this3.totalCount = data.count;
      });
    },
    showCreate: function showCreate() {
      this.dataModel = {};
      var allRoles = this.allRoles;
      _.forEach(allRoles, function (role) {
        role.selected = false;
      });
      this.dataModel.roles = allRoles;
      this.editModal = true;
    },
    showDestroy: function showDestroy(index) {
      this.destroyData = this.tableData[index];
      this.destroyModal = true;
    },
    destroy: function destroy(result) {
      var _this4 = this;

      if (result && this.destroyData) {
        this.$http.delete('admin/users/' + this.destroyData.id).then(function () {
          _this4.$Message.success('删除成功!');
          _this4.refresh();
        });
      }
      this.destroyModal = false;
    },
    refresh: function refresh() {
      if (this.currentPage) {
        this.changePage(this.currentPage);
      }
    },
    showEdit: function showEdit(index) {
      var data = this.tableData[index];
      this.dataModel.id = data.id;
      this.dataModel.username = data.username;
      this.dataModel.enabled = !data.disabled;
      this.dataModel.password = '';
      var allRoles = this.allRoles;
      var userRoles = data.roles;
      _.forEach(allRoles, function (role) {
        role.selected = false;
        _.forEach(userRoles, function (userRole) {
          if (role.name === userRole.name) {
            role.selected = true;
            return false;
          }
        });
      });
      this.dataModel.roles = allRoles;
      this.editModal = true;
    },
    edit: function edit(result) {
      var _this5 = this;

      if (result) {
        this.$refs['dataModel'].validate(function (valid) {
          if (valid) {
            var dataId = _this5.dataModel.id;
            var roles = [];
            _.forEach(_this5.dataModel.roles, function (role) {
              if (role.selected) {
                roles.push(role.name);
              }
            });
            if (dataId) {
              // 编辑
              _this5.$http.put('admin/users/' + dataId, {
                password: _this5.dataModel.password || undefined,
                username: _this5.dataModel.username || undefined,
                disabled: !_this5.dataModel.enabled,
                roles: roles
              }).then(function () {
                _this5.$Message.success('编辑成功!');
                _this5.refresh();
              });
            } else {
              // 新增
              _this5.$http.post('admin/users', {
                password: _this5.dataModel.password || undefined,
                username: _this5.dataModel.username || undefined,
                disabled: !_this5.dataModel.enabled,
                roles: roles
              }).then(function () {
                _this5.$Message.success('新增成功!');
                _this5.refresh();
              });
            }
          } else {
            _this5.$Message.error('表单验证失败!');
          }
        });
      } else {
        // TODO - 页面值不会被重置 - https://github.com/iview/iview/issues/970
        // this.$refs['dataModel'].resetFields();
      }
    }
  }
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_bus__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__(6);
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Navigator',
  data: function data() {
    return {
      itemNames: ['控制台']
    };
  },
  created: function created() {
    var _this = this;

    // Update navigator when route chagnes
    __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].$on('route-change', function (data) {
      var toRoute = data.to;
      var toPath = toRoute.path.substr(1);
      var pathArr = toPath.split('/');
      var itemNames = [];
      var temp = '';
      pathArr.forEach(function (path) {
        if (temp) {
          temp += ':';
        }
        temp += path;
        itemNames.push(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */].permissionMenuMap[temp] || 'Unknown menu');
      });
      _this.itemNames = itemNames;
    });
  }
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_bus__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SideMenu',
  props: ['permissions'],
  data: function data() {
    return {
      menuItemArr: [],
      activeMenu: ''
    };
  },

  computed: {},
  methods: {
    routeTo: function routeTo(route) {
      if (route) {
        var toRoute = '/' + route.split(':').join('/');
        this.$router.push(toRoute);
      }
    }
  },
  created: function created() {
    var _this = this;

    var route = this.$router.currentRoute;
    var path = route.path.substr(1);
    this.menuItemArr = [path.split('/')[0]];
    this.activeMenu = path.split('/').join(':');

    // Update menu when route chagnes
    __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].$on('route-change', function (data) {
      var toRoute = data.to;
      var toPath = toRoute.path.substr(1);
      _this.menuItemArr = [toPath.split('/')[0]];
      _this.activeMenu = toPath.split('/').join(':');
    });
  }
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TopMenu',
  data: function data() {
    return {
      passwordModal: false,
      dataModel: {},
      rules: {
        oldPassword: [{ required: true, message: 'Invalid old password', trigger: 'blur' }],
        newPassword: [{ required: true, message: 'Invalid new password', trigger: 'blur' }, { type: 'string', min: 6, message: 'Length >= 6', trigger: 'blur' }],
        newPasswordRepeat: [{ required: true, message: 'Invalid new password', trigger: 'blur' }, { type: 'string', min: 6, message: 'Length >= 6', trigger: 'blur' }]
      }
    };
  },

  methods: {
    action: function action(name) {
      var _this = this;

      if (name === 'logout') {
        this.$http.delete('sessions').then(function () {
          _this.$store.commit('clearUser');
        });
      } else if (name === 'password') {
        this.dataModel = {};
        this.passwordModal = true;
      }
    },
    confirm: function confirm(result) {
      var _this2 = this;

      if (result) {
        this.$refs['dataModel'].validate(function (valid) {
          if (valid) {
            _this2.$http.post('sessions/update-password', {
              oldPassword: _this2.dataModel.oldPassword,
              newPassword: _this2.dataModel.newPassword,
              newPasswordRepeat: _this2.dataModel.newPasswordRepeat
            }).then(function () {
              _this2.$Message.success('Password updated!');
            });
          } else {
            _this2.$Message.error('Form invalid!');
          }
        });
      } else {
        // TODO: remove workround
        // Workround for - https://github.com/iview/iview/issues/970
        this.$refs['dataModel'].resetFields();
      }
    }
  }
});

/***/ }),
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Dashboard__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_admin_User__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_Role__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_Permission__ = __webpack_require__(166);







__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/dashboard',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Dashboard__["a" /* default */]
  }, {
    path: '/admin/user',
    component: __WEBPACK_IMPORTED_MODULE_3__components_admin_User__["a" /* default */]
  }, {
    path: '/admin/role',
    component: __WEBPACK_IMPORTED_MODULE_4__components_admin_Role__["a" /* default */]
  }, {
    path: '/admin/permission',
    component: __WEBPACK_IMPORTED_MODULE_5__components_admin_Permission__["a" /* default */]
  }, {
    path: '/admin/driver',
    component: function component() {
      return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 187));
    }
  }, {
    path: '/admin/car',
    component: function component() {
      return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 186));
    }
  }, {
    path: '/admin/userOrder',
    component: function component() {
      return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 188));
    }
  }]
}));

/***/ }),
/* 145 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 146 */,
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(7);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06457398_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(152)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-06457398"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06457398_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06457398_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 148 */,
/* 149 */,
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_view_design_dist_styles_iview_css__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_view_design_dist_styles_iview_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_view_design_dist_styles_iview_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_view_design__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_view_design___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_view_design__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_resource__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__event_bus__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__router__ = __webpack_require__(144);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_view_design___default.a);

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.options.root = 'https://baili-api.dcyu.com/api/v1';

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.interceptors.push(function (request, next) {
  request.credentials = true; // Enable cookie sending

  this.$Loading.start();

  // Global http error processing
  next(function (response) {
    var data = response.data;
    if (data && data.code > 0) {
      this.$Message.warning({
        content: data.message || 'Unknown error',
        duration: 5
      });
      this.$Loading.error();
    } else if (response && response.status !== 200) {
      var message = response.statusText;
      switch (response.status) {
        case 404:
          message = 'Page not found';
          break;
        case 500:
          message = 'Server internal error!';
          break;
        default:
          break;
      }
      this.$Message.warning({
        content: message || 'Unknown error',
        duration: 5
      });
      this.$Loading.error();
    } else {
      this.$Loading.finish();
    }
  });
});

var store = new __WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */].Store({
  state: {
    user: {
      userInfo: null,
      roles: [],
      permissions: []
    }
  },
  mutations: {
    /* eslint-disable */
    clearUser: function clearUser(state) {
      state.user.userInfo = null;
      state.user.roles = [];
      state.user.permissions = [];
    },
    updateUser: function updateUser(state, data) {
      if (data.id && data.username) {
        state.user.userInfo = {
          id: data.id,
          username: data.username
        };
        state.user.roles = data.roles || [];
        state.user.permissions = data.permissions || [];
      }
    }
  }
});

__WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */].beforeEach(function (to, from, next) {
  var path = to.path.substr(1);
  var pathPermission = path.split('/').join(':');
  var permissions = store.state.user.permissions || [];
  if (permissions.indexOf(pathPermission) < 0) {
    next(false);
  } else {
    next();
  }
});

__WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */].afterEach(function (to, from) {
  __WEBPACK_IMPORTED_MODULE_6__event_bus__["a" /* default */].$emit('route-change', {
    to: to,
    from: from
  });
});

new __WEBPACK_IMPORTED_MODULE_2_vue__["default"]({
  el: '#app',
  store: store,
  router: __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_5__App__["a" /* default */] }
});
/* eslint-enable */

/***/ }),
/* 151 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 152 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 153 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 154 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 155 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 156 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 157 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 158 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 159 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 16,
	"./af.js": 16,
	"./ar": 23,
	"./ar-dz": 17,
	"./ar-dz.js": 17,
	"./ar-kw": 18,
	"./ar-kw.js": 18,
	"./ar-ly": 19,
	"./ar-ly.js": 19,
	"./ar-ma": 20,
	"./ar-ma.js": 20,
	"./ar-sa": 21,
	"./ar-sa.js": 21,
	"./ar-tn": 22,
	"./ar-tn.js": 22,
	"./ar.js": 23,
	"./az": 24,
	"./az.js": 24,
	"./be": 25,
	"./be.js": 25,
	"./bg": 26,
	"./bg.js": 26,
	"./bm": 27,
	"./bm.js": 27,
	"./bn": 28,
	"./bn.js": 28,
	"./bo": 29,
	"./bo.js": 29,
	"./br": 30,
	"./br.js": 30,
	"./bs": 31,
	"./bs.js": 31,
	"./ca": 32,
	"./ca.js": 32,
	"./cs": 33,
	"./cs.js": 33,
	"./cv": 34,
	"./cv.js": 34,
	"./cy": 35,
	"./cy.js": 35,
	"./da": 36,
	"./da.js": 36,
	"./de": 39,
	"./de-at": 37,
	"./de-at.js": 37,
	"./de-ch": 38,
	"./de-ch.js": 38,
	"./de.js": 39,
	"./dv": 40,
	"./dv.js": 40,
	"./el": 41,
	"./el.js": 41,
	"./en-SG": 42,
	"./en-SG.js": 42,
	"./en-au": 43,
	"./en-au.js": 43,
	"./en-ca": 44,
	"./en-ca.js": 44,
	"./en-gb": 45,
	"./en-gb.js": 45,
	"./en-ie": 46,
	"./en-ie.js": 46,
	"./en-il": 47,
	"./en-il.js": 47,
	"./en-nz": 48,
	"./en-nz.js": 48,
	"./eo": 49,
	"./eo.js": 49,
	"./es": 52,
	"./es-do": 50,
	"./es-do.js": 50,
	"./es-us": 51,
	"./es-us.js": 51,
	"./es.js": 52,
	"./et": 53,
	"./et.js": 53,
	"./eu": 54,
	"./eu.js": 54,
	"./fa": 55,
	"./fa.js": 55,
	"./fi": 56,
	"./fi.js": 56,
	"./fo": 57,
	"./fo.js": 57,
	"./fr": 60,
	"./fr-ca": 58,
	"./fr-ca.js": 58,
	"./fr-ch": 59,
	"./fr-ch.js": 59,
	"./fr.js": 60,
	"./fy": 61,
	"./fy.js": 61,
	"./ga": 62,
	"./ga.js": 62,
	"./gd": 63,
	"./gd.js": 63,
	"./gl": 64,
	"./gl.js": 64,
	"./gom-latn": 65,
	"./gom-latn.js": 65,
	"./gu": 66,
	"./gu.js": 66,
	"./he": 67,
	"./he.js": 67,
	"./hi": 68,
	"./hi.js": 68,
	"./hr": 69,
	"./hr.js": 69,
	"./hu": 70,
	"./hu.js": 70,
	"./hy-am": 71,
	"./hy-am.js": 71,
	"./id": 72,
	"./id.js": 72,
	"./is": 73,
	"./is.js": 73,
	"./it": 75,
	"./it-ch": 74,
	"./it-ch.js": 74,
	"./it.js": 75,
	"./ja": 76,
	"./ja.js": 76,
	"./jv": 77,
	"./jv.js": 77,
	"./ka": 78,
	"./ka.js": 78,
	"./kk": 79,
	"./kk.js": 79,
	"./km": 80,
	"./km.js": 80,
	"./kn": 81,
	"./kn.js": 81,
	"./ko": 82,
	"./ko.js": 82,
	"./ku": 83,
	"./ku.js": 83,
	"./ky": 84,
	"./ky.js": 84,
	"./lb": 85,
	"./lb.js": 85,
	"./lo": 86,
	"./lo.js": 86,
	"./lt": 87,
	"./lt.js": 87,
	"./lv": 88,
	"./lv.js": 88,
	"./me": 89,
	"./me.js": 89,
	"./mi": 90,
	"./mi.js": 90,
	"./mk": 91,
	"./mk.js": 91,
	"./ml": 92,
	"./ml.js": 92,
	"./mn": 93,
	"./mn.js": 93,
	"./mr": 94,
	"./mr.js": 94,
	"./ms": 96,
	"./ms-my": 95,
	"./ms-my.js": 95,
	"./ms.js": 96,
	"./mt": 97,
	"./mt.js": 97,
	"./my": 98,
	"./my.js": 98,
	"./nb": 99,
	"./nb.js": 99,
	"./ne": 100,
	"./ne.js": 100,
	"./nl": 102,
	"./nl-be": 101,
	"./nl-be.js": 101,
	"./nl.js": 102,
	"./nn": 103,
	"./nn.js": 103,
	"./pa-in": 104,
	"./pa-in.js": 104,
	"./pl": 105,
	"./pl.js": 105,
	"./pt": 107,
	"./pt-br": 106,
	"./pt-br.js": 106,
	"./pt.js": 107,
	"./ro": 108,
	"./ro.js": 108,
	"./ru": 109,
	"./ru.js": 109,
	"./sd": 110,
	"./sd.js": 110,
	"./se": 111,
	"./se.js": 111,
	"./si": 112,
	"./si.js": 112,
	"./sk": 113,
	"./sk.js": 113,
	"./sl": 114,
	"./sl.js": 114,
	"./sq": 115,
	"./sq.js": 115,
	"./sr": 117,
	"./sr-cyrl": 116,
	"./sr-cyrl.js": 116,
	"./sr.js": 117,
	"./ss": 118,
	"./ss.js": 118,
	"./sv": 119,
	"./sv.js": 119,
	"./sw": 120,
	"./sw.js": 120,
	"./ta": 121,
	"./ta.js": 121,
	"./te": 122,
	"./te.js": 122,
	"./tet": 123,
	"./tet.js": 123,
	"./tg": 124,
	"./tg.js": 124,
	"./th": 125,
	"./th.js": 125,
	"./tl-ph": 126,
	"./tl-ph.js": 126,
	"./tlh": 127,
	"./tlh.js": 127,
	"./tr": 128,
	"./tr.js": 128,
	"./tzl": 129,
	"./tzl.js": 129,
	"./tzm": 131,
	"./tzm-latn": 130,
	"./tzm-latn.js": 130,
	"./tzm.js": 131,
	"./ug-cn": 132,
	"./ug-cn.js": 132,
	"./uk": 133,
	"./uk.js": 133,
	"./ur": 134,
	"./ur.js": 134,
	"./uz": 136,
	"./uz-latn": 135,
	"./uz-latn.js": 135,
	"./uz.js": 136,
	"./vi": 137,
	"./vi.js": 137,
	"./x-pseudo": 138,
	"./x-pseudo.js": 138,
	"./yo": 139,
	"./yo.js": 139,
	"./zh-cn": 140,
	"./zh-cn.js": 140,
	"./zh-hk": 141,
	"./zh-hk.js": 141,
	"./zh-tw": 142,
	"./zh-tw.js": 142
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 160;

/***/ }),
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__ = __webpack_require__(8);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6886925c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(156)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6886925c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6886925c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6886925c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(9);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69cc1d02_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(157)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-69cc1d02"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69cc1d02_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69cc1d02_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Permission_vue__ = __webpack_require__(10);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ebdbe40a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Permission_vue__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(159)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ebdbe40a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Permission_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ebdbe40a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Permission_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ebdbe40a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Permission_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Role_vue__ = __webpack_require__(11);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05e451b9_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Role_vue__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(151)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-05e451b9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Role_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05e451b9_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Role_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05e451b9_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Role_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_User_vue__ = __webpack_require__(12);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2344b060_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_User_vue__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(153)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2344b060"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_User_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2344b060_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_User_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2344b060_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_User_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navigator_vue__ = __webpack_require__(13);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23eb9983_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navigator_vue__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(154)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-23eb9983"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navigator_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23eb9983_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navigator_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23eb9983_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navigator_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideMenu_vue__ = __webpack_require__(14);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_86323b54_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideMenu_vue__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(158)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-86323b54"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_86323b54_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideMenu_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_86323b54_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideMenu_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopMenu_vue__ = __webpack_require__(15);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3905fc5c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopMenu_vue__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(155)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3905fc5c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3905fc5c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopMenu_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3905fc5c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopMenu_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"admin-user-view"},[_c('Card',{attrs:{"dis-hover":""}},[_c('Row',{staticClass:"table-action-section",attrs:{"type":"flex","justify":"center"}},[_c('Col',{attrs:{"span":"22"}},[_c('b',[_vm._v("角色列表")])]),_vm._v(" "),_c('Col',{attrs:{"span":"2"}},[_c('Button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.showCreate}},[_vm._v("新增")])],1)],1),_vm._v(" "),_c('Table',{attrs:{"border":"","data":_vm.tableData,"columns":_vm.tableColumns,"stripe":""}}),_vm._v(" "),_c('div',{staticStyle:{"margin":"10px","overflow":"hidden"}},[_c('div',{staticStyle:{"float":"right"}},[_c('Page',{attrs:{"show-total":"","total":_vm.totalCount,"page-size":_vm.pageSize},on:{"on-change":_vm.changePage}})],1)])],1),_vm._v(" "),_c('Modal',{attrs:{"width":"400","title":"编辑角色信息"},on:{"on-ok":function($event){return _vm.edit(true)},"on-cancel":function($event){return _vm.edit(false)}},model:{value:(_vm.editModal),callback:function ($$v) {_vm.editModal=$$v},expression:"editModal"}},[_c('Form',{ref:"dataModel",attrs:{"model":_vm.dataModel,"rules":_vm.rules,"label-width":80}},[_c('Form-item',{attrs:{"label":"角色","prop":"name"}},[_c('Input',{attrs:{"placeholder":"请输入角色名称","disabled":_vm.dataModel.name === 'admin'},model:{value:(_vm.dataModel.name),callback:function ($$v) {_vm.$set(_vm.dataModel, "name", $$v)},expression:"dataModel.name"}})],1),_vm._v(" "),_c('Form-item',{attrs:{"label":"备注","prop":"comment"}},[_c('Input',{attrs:{"placeholder":"请输入角色备注","disabled":_vm.dataModel.name === 'admin'},model:{value:(_vm.dataModel.comment),callback:function ($$v) {_vm.$set(_vm.dataModel, "comment", $$v)},expression:"dataModel.comment"}})],1)],1)],1),_vm._v(" "),_c('Modal',{attrs:{"width":"400","title":"编辑角色权限"},on:{"on-ok":function($event){return _vm.editPermission(true)},"on-cancel":function($event){return _vm.editPermission(false)}},model:{value:(_vm.permissionModal),callback:function ($$v) {_vm.permissionModal=$$v},expression:"permissionModal"}},[_c('Form',{attrs:{"label-width":80}},[_c('Form-item',{attrs:{"label":"权限"}},[_c('Checkbox-group',_vm._l((_vm.allPermissions),function(permission){return _c('Checkbox',{key:permission.name,attrs:{"disabled":permission.name === 'dashboard',"label":permission.name},model:{value:(permission.selected),callback:function ($$v) {_vm.$set(permission, "selected", $$v)},expression:"permission.selected"}})}),1)],1)],1)],1),_vm._v(" "),_c('Modal',{attrs:{"width":"300"},model:{value:(_vm.destroyModal),callback:function ($$v) {_vm.destroyModal=$$v},expression:"destroyModal"}},[_c('p',{staticStyle:{"color":"#f60","text-align":"center"},attrs:{"slot":"header"},slot:"header"},[_c('Icon',{attrs:{"type":"information-circled"}}),_vm._v(" "),_c('span',[_vm._v("角色删除确认")])],1),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center","font-size":"14px"}},[_c('p',[_vm._v("角色："+_vm._s(_vm.destroyData ? _vm.destroyData.name : '-'))]),_vm._v(" "),_c('p',[_vm._v("将被删除且无法恢复，是否继续？")])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('Button',{attrs:{"type":"error","size":"large","long":""},on:{"click":function($event){return _vm.destroy(true)}}},[_vm._v("删除")])],1)])],1)}
var staticRenderFns = []


/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-section",staticStyle:{"height":"100%","min-height":"100%"}},[(_vm.notLogin)?_c('login-view',{directives:[{name:"show",rawName:"v-show",value:(_vm.loginSettle),expression:"loginSettle"}]}):_c('div',{staticClass:"layout"},[_c('Row',{staticStyle:{"height":"100%","min-height":"100%"},attrs:{"type":"flex"}},[_c('i-col',{staticClass:"layout-menu-left",attrs:{"span":"3"}},[_c('side-menu',{attrs:{"permissions":_vm.permissions}})],1),_vm._v(" "),_c('i-col',{attrs:{"span":"21"}},[(_vm.errorMessage && _vm.errorMessage.length)?_c('div',{staticClass:"error-wrapper"},[_c('Alert',{attrs:{"type":"warning","show-icon":""}},[_c('i',{staticClass:"error-message"},[_vm._v(_vm._s(_vm.错误消息))])])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"layout-header"},[_c('Row',[_c('Col',{attrs:{"span":"22"}},[_vm._v(" ")]),_vm._v(" "),_c('Col',{staticClass:"top-menu-section",attrs:{"span":"2"}},[_c('top-menu')],1)],1)],1),_vm._v(" "),_c('navigator'),_vm._v(" "),_c('router-view')],1)],1)],1)],1)}
var staticRenderFns = []


/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"admin-user-view"},[_c('Card',{attrs:{"dis-hover":""}},[_c('Row',{staticClass:"table-action-section",attrs:{"type":"flex","justify":"center"}},[_c('Col',{attrs:{"span":"22"}},[_c('b',[_vm._v("用户列表")])]),_vm._v(" "),_c('Col',{attrs:{"span":"2"}},[_c('Button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.showCreate}},[_vm._v("新增")])],1)],1),_vm._v(" "),_c('Table',{attrs:{"border":"","data":_vm.tableData,"columns":_vm.tableColumns,"stripe":""}}),_vm._v(" "),_c('div',{staticStyle:{"margin":"10px","overflow":"hidden"}},[_c('div',{staticStyle:{"float":"right"}},[_c('Page',{attrs:{"show-total":"","total":_vm.totalCount,"page-size":_vm.pageSize},on:{"on-change":_vm.changePage}})],1)])],1),_vm._v(" "),_c('Modal',{attrs:{"width":"400","title":"编辑用户信息"},on:{"on-ok":function($event){return _vm.edit(true)},"on-cancel":function($event){return _vm.edit(false)}},model:{value:(_vm.editModal),callback:function ($$v) {_vm.editModal=$$v},expression:"editModal"}},[_c('Form',{ref:"dataModel",attrs:{"model":_vm.dataModel,"rules":_vm.rules,"label-width":80}},[_c('Form-item',{attrs:{"label":"姓名","prop":"username"}},[_c('Input',{attrs:{"placeholder":"请输入姓名","disabled":_vm.dataModel.username === 'admin'},model:{value:(_vm.dataModel.username),callback:function ($$v) {_vm.$set(_vm.dataModel, "username", $$v)},expression:"dataModel.username"}})],1),_vm._v(" "),_c('Form-item',{attrs:{"label":"密码","prop":"password"}},[_c('Input',{attrs:{"placeholder":"********"},model:{value:(_vm.dataModel.password),callback:function ($$v) {_vm.$set(_vm.dataModel, "password", $$v)},expression:"dataModel.password"}})],1),_vm._v(" "),_c('Form-item',{attrs:{"label":"启用","prop":"enabled"}},[_c('i-switch',{attrs:{"disabled":_vm.dataModel.username === 'admin'},model:{value:(_vm.dataModel.enabled),callback:function ($$v) {_vm.$set(_vm.dataModel, "enabled", $$v)},expression:"dataModel.enabled"}})],1),_vm._v(" "),_c('Form-item',{attrs:{"label":"角色"}},[_c('Checkbox-group',_vm._l((_vm.allRoles),function(role){return _c('Checkbox',{key:role.name,attrs:{"label":role.name,"disabled":_vm.dataModel.username === role.name},model:{value:(role.selected),callback:function ($$v) {_vm.$set(role, "selected", $$v)},expression:"role.selected"}})}),1)],1)],1)],1),_vm._v(" "),_c('Modal',{attrs:{"width":"300"},model:{value:(_vm.destroyModal),callback:function ($$v) {_vm.destroyModal=$$v},expression:"destroyModal"}},[_c('p',{staticStyle:{"color":"#f60","text-align":"center"},attrs:{"slot":"header"},slot:"header"},[_c('Icon',{attrs:{"type":"information-circled"}}),_vm._v(" "),_c('span',[_vm._v("用户删除确认")])],1),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center","font-size":"14px"}},[_c('p',[_vm._v("用户："+_vm._s(_vm.destroyData ? _vm.destroyData.username : '-'))]),_vm._v(" "),_c('p',[_vm._v("将被删除且无法恢复，是否继续？")])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('Button',{attrs:{"type":"error","size":"large","long":""},on:{"click":function($event){return _vm.destroy(true)}}},[_vm._v("删除")])],1)])],1)}
var staticRenderFns = []


/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-breadcrumb"},[_c('Breadcrumb',_vm._l((_vm.itemNames),function(itemName){return _c('Breadcrumb-item',{key:itemName},[_vm._v(_vm._s(itemName))])}),1)],1)}
var staticRenderFns = []


/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-menu"},[_c('Dropdown',{attrs:{"trigger":"click"},on:{"on-click":_vm.action}},[_c('a',{attrs:{"href":"javascript:void(0)"}},[_c('Icon',{attrs:{"type":"ios-person","size":"18"}}),_vm._v(" "),_c('Icon',{attrs:{"type":"ios-arrow-down","size":"18"}})],1),_vm._v(" "),_c('Dropdown-menu',{attrs:{"slot":"list"},slot:"list"},[_c('Dropdown-item',{attrs:{"name":"password"}},[_vm._v("修改密码")]),_vm._v(" "),_c('Dropdown-item',{attrs:{"name":"logout"}},[_vm._v("登出")])],1)],1),_vm._v(" "),_c('Modal',{attrs:{"width":"400","title":"更改密码"},on:{"on-ok":function($event){return _vm.confirm(true)},"on-cancel":function($event){return _vm.confirm(false)}},model:{value:(_vm.passwordModal),callback:function ($$v) {_vm.passwordModal=$$v},expression:"passwordModal"}},[_c('Form',{ref:"dataModel",attrs:{"model":_vm.dataModel,"rules":_vm.rules,"label-width":100}},[_c('Form-item',{attrs:{"label":"旧密码","prop":"oldPassword"}},[_c('Input',{attrs:{"type":"password","placeholder":"输入旧密码"},model:{value:(_vm.dataModel.oldPassword),callback:function ($$v) {_vm.$set(_vm.dataModel, "oldPassword", $$v)},expression:"dataModel.oldPassword"}})],1),_vm._v(" "),_c('Form-item',{attrs:{"label":"新密码","prop":"newPassword"}},[_c('Input',{attrs:{"type":"password","placeholder":"输入新密码"},model:{value:(_vm.dataModel.newPassword),callback:function ($$v) {_vm.$set(_vm.dataModel, "newPassword", $$v)},expression:"dataModel.newPassword"}})],1),_vm._v(" "),_c('Form-item',{attrs:{"label":"重复新密码","prop":"newPasswordRepeat"}},[_c('Input',{attrs:{"type":"password","placeholder":"重复输入新密码"},model:{value:(_vm.dataModel.newPasswordRepeat),callback:function ($$v) {_vm.$set(_vm.dataModel, "newPasswordRepeat", $$v)},expression:"dataModel.newPasswordRepeat"}})],1)],1)],1)],1)}
var staticRenderFns = []


/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Row',{attrs:{"type":"flex","justify":"space-around"}},[_c('Col',{staticClass:"dash-row",attrs:{"span":"5"}},[_c('Card',[_c('p',{attrs:{"slot":"title"},slot:"title"},[_vm._v("欢迎")]),_vm._v(" "),_c('p',[_vm._v("欢迎，用户"),_c('b',[_vm._v(_vm._s(_vm.userInfo.username))])]),_vm._v(" "),_c('p',[_vm._v(" ")]),_vm._v(" "),_c('p',[_vm._v(" ")]),_vm._v(" "),_c('p',[_vm._v(" ")]),_vm._v(" "),_c('p',[_vm._v(" ")])])],1),_vm._v(" "),_c('Col',{attrs:{"span":"5"}},[_c('Card',[_c('p',{attrs:{"slot":"title"},slot:"title"},[_vm._v("你的角色")]),_vm._v(" "),_vm._l((_vm.roles),function(role){return _c('p',{key:role},[_vm._v(_vm._s(role))])}),_vm._v(" "),_c('p',[_vm._v(" ")]),_vm._v(" "),_c('p',[_vm._v(" ")]),_vm._v(" "),_c('p',[_vm._v(" ")])],2)],1),_vm._v(" "),_c('Col',{attrs:{"span":"5"}},[_c('Card',[_c('p',{attrs:{"slot":"title"},slot:"title"},[_vm._v("您的权限")]),_vm._v(" "),_vm._l((_vm.permissions),function(permission){return _c('p',{key:permission},[_vm._v(_vm._s(permission))])})],2)],1),_vm._v(" "),_c('Col',{attrs:{"span":"5"}},[_c('Card',[_c('p',{attrs:{"slot":"title"},slot:"title"},[_vm._v("要办的事")]),_vm._v(" "),_c('p',[_vm._v("TODO1")]),_vm._v(" "),_c('p',[_vm._v("TODO2")]),_vm._v(" "),_c('p',[_vm._v("TODO3")]),_vm._v(" "),_c('p',[_vm._v(" ")]),_vm._v(" "),_c('p',[_vm._v(" ")])])],1)],1)}
var staticRenderFns = []


/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Row',{staticClass:"top-row",attrs:{"justify":"center","align":"middle"}},[_c('Col',{staticClass:"title-col",attrs:{"span":"8","offset":"8"}},[_vm._v("后台管理平台")])],1),_vm._v(" "),_c('Row',{staticClass:"login-row",attrs:{"justify":"center","align":"middle"}},[_c('Col',{staticClass:"login-col",attrs:{"span":"24"}},[_c('Card',{staticClass:"login-card"},[_c('p',{attrs:{"slot":"title"},slot:"title"},[_vm._v("\n          请登录\n        ")]),_vm._v(" "),_c('div',{staticClass:"login-form"},[_c('Form',{ref:"formLogin",attrs:{"model":_vm.formLogin,"rules":_vm.ruleCustom,"label-width":90}},[_c('Form-item',{attrs:{"label":"用户","prop":"username"}},[_c('Input',{attrs:{"type":"text"},model:{value:(_vm.formLogin.username),callback:function ($$v) {_vm.$set(_vm.formLogin, "username", $$v)},expression:"formLogin.username"}})],1),_vm._v(" "),_c('Form-item',{attrs:{"label":"密码","prop":"password"}},[_c('Input',{attrs:{"type":"password"},model:{value:(_vm.formLogin.password),callback:function ($$v) {_vm.$set(_vm.formLogin, "password", $$v)},expression:"formLogin.password"}})],1),_vm._v(" "),_c('Form-item',[_c('Button',{attrs:{"long":"","type":"primary"},on:{"click":function($event){return _vm.handleSubmit('formLogin')}}},[_vm._v("登录")])],1)],1)],1)]),_vm._v(" "),_c('Poptip',{staticClass:"tip-section",attrs:{"trigger":"hover","placement":"bottom-start"}},[_c('Button',{attrs:{"small":"","type":"dashed","shape":"circle"}},[_vm._v("登录信息")]),_vm._v(" "),_c('div',{staticClass:"tip-table",attrs:{"slot":"content"},slot:"content"},[_c('table',[_c('tbody',[_c('tr',[_c('td',[_vm._v("admin / adminpwd")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("test / testpwd")])])])])])],1)],1)],1)],1)}
var staticRenderFns = []


/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Menu',{attrs:{"theme":"dark","width":"auto","open-names":_vm.menuItemArr,"active-name":_vm.activeMenu},on:{"on-select":_vm.routeTo}},[_c('Row',{attrs:{"justify":"center","align":"middle"}},[_c('Col',{staticClass:"layout-logo-left",attrs:{"span":"22","offset":"1"}},[_vm._v("后台管理平台")])],1),_vm._v(" "),(_vm.permissions['dashboard'])?_c('Menu-item',{attrs:{"name":"dashboard"}},[_c('Icon',{attrs:{"type":"md-desktop"}}),_vm._v("\n    "+_vm._s(_vm.permissions['dashboard'].menuName)+"\n  ")],1):_vm._e(),_vm._v(" "),(_vm.permissions['admin'])?_c('Submenu',{attrs:{"name":"admin"}},[_c('template',{slot:"title"},[_c('Icon',{attrs:{"type":"md-settings"}}),_vm._v("\n      "+_vm._s(_vm.permissions['admin'].menuName)+"\n    ")],1),_vm._v(" "),(_vm.permissions['admin:user'])?_c('Menu-item',{attrs:{"name":"admin:user"}},[_vm._v(_vm._s(_vm.permissions['admin:user'].menuName))]):_vm._e(),_vm._v(" "),(_vm.permissions['admin:role'])?_c('Menu-item',{attrs:{"name":"admin:role"}},[_vm._v(_vm._s(_vm.permissions['admin:role'].menuName))]):_vm._e(),_vm._v(" "),(_vm.permissions['admin:permission'])?_c('Menu-item',{attrs:{"name":"admin:permission"}},[_vm._v(_vm._s(_vm.permissions['admin:permission'].menuName))]):_vm._e(),_vm._v(" "),(_vm.permissions['admin:driver'])?_c('Menu-item',{attrs:{"name":"admin:driver"}},[_vm._v(_vm._s(_vm.permissions['admin:driver'].menuName))]):_vm._e(),_vm._v(" "),(_vm.permissions['admin:car'])?_c('Menu-item',{attrs:{"name":"admin:car"}},[_vm._v(_vm._s(_vm.permissions['admin:car'].menuName))]):_vm._e(),_vm._v(" "),(_vm.permissions['admin:userOrder'])?_c('Menu-item',{attrs:{"name":"admin:userOrder"}},[_vm._v(_vm._s(_vm.permissions['admin:userOrder'].menuName))]):_vm._e()],2):_vm._e()],1)}
var staticRenderFns = []


/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"admin-user-view"},[_c('Card',{attrs:{"dis-hover":""}},[_c('Row',{staticClass:"table-action-section",attrs:{"type":"flex","justify":"center"}},[_c('Col',{attrs:{"span":"22"}},[_c('b',[_vm._v("权限")])]),_vm._v(" "),_c('Col',{attrs:{"span":"2"}},[_c('Button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.showCreate}},[_vm._v("添加")])],1)],1),_vm._v(" "),_c('Table',{attrs:{"border":"","data":_vm.tableData,"columns":_vm.tableColumns,"stripe":""}}),_vm._v(" "),_c('div',{staticStyle:{"margin":"10px","overflow":"hidden"}},[_c('div',{staticStyle:{"float":"right"}},[_c('Page',{attrs:{"show-total":"","total":_vm.totalCount,"page-size":_vm.pageSize},on:{"on-change":_vm.changePage}})],1)])],1),_vm._v(" "),_c('Modal',{attrs:{"width":"400","title":"更新权限"},on:{"on-ok":function($event){return _vm.edit(true)},"on-cancel":function($event){return _vm.edit(false)}},model:{value:(_vm.editModal),callback:function ($$v) {_vm.editModal=$$v},expression:"editModal"}},[_c('Form',{ref:"dataModel",attrs:{"model":_vm.dataModel,"rules":_vm.rules,"label-width":90}},[_c('Form-item',{attrs:{"label":"名字","prop":"name"}},[_c('Input',{attrs:{"placeholder":"输入权限名称"},model:{value:(_vm.dataModel.name),callback:function ($$v) {_vm.$set(_vm.dataModel, "name", $$v)},expression:"dataModel.name"}})],1),_vm._v(" "),_c('Form-item',{attrs:{"label":"注释","prop":"comment"}},[_c('Input',{attrs:{"placeholder":"输入权限注释"},model:{value:(_vm.dataModel.comment),callback:function ($$v) {_vm.$set(_vm.dataModel, "comment", $$v)},expression:"dataModel.comment"}})],1)],1)],1),_vm._v(" "),_c('Modal',{attrs:{"width":"350"},model:{value:(_vm.destroyModal),callback:function ($$v) {_vm.destroyModal=$$v},expression:"destroyModal"}},[_c('p',{staticStyle:{"color":"#f60","text-align":"center"},attrs:{"slot":"header"},slot:"header"},[_c('Icon',{attrs:{"type":"information-circled"}}),_vm._v(" "),_c('span',[_vm._v("确认")])],1),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center","font-size":"14px"}},[_c('p',[_vm._v("删除角色:"+_vm._s(_vm.destroyData ? _vm.destroyData.name : '-')+" ?")]),_vm._v(" "),_c('p',[_vm._v("删除的数据无法恢复!")])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('Button',{attrs:{"type":"error","size":"large","long":""},on:{"click":function($event){return _vm.destroy(true)}}},[_vm._v("删除")])],1)])],1)}
var staticRenderFns = []


/***/ }),
/* 181 */,
/* 182 */,
/* 183 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[150]);


// WEBPACK FOOTER //
// static/js/app.6387debdfb62b14235d3.js